export function track(eventName, eventData = {}) {
  if (typeof window !== 'undefined' && typeof window.umami?.track === 'function') {
    window.umami.track(eventName, eventData);
  }
}
